import { render, staticRenderFns } from "./precariteOperations.vue?vue&type=template&id=7128f4aa&scoped=true"
import script from "./precariteOperations.vue?vue&type=script&lang=js"
export * from "./precariteOperations.vue?vue&type=script&lang=js"
import style0 from "./precariteOperations.vue?vue&type=style&index=0&id=7128f4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128f4aa",
  null
  
)

export default component.exports